<script lang="ts">
    import translate from '../../../../../lib/translate'
    import {IProduct} from '../../../types/Show'
    import label from './ProductDetails.translation'
    export let product: IProduct
</script>

<div class="bietagent-next-details">
    {#if product}
        <div class="auction-box-scrollable">
            <h3>
                {product.name}
                <span class="sku">
                    <span class="label">{translate(label.productId)}</span>
                    <span class="value">{product.productId}</span>
                </span>
            </h3>
            
            <!-- nur mal eine idee -->
            <img src="{product.image.size800}" 
                 alt="{product.name}"
            >
            
            <table class="data-table product-attribute-table">
                <tbody>
                    {#if product.dimensions}
                        <tr>
                            <th>{translate(label.productSize)}</th>
                            <td>
                                {product.type}, {product.dimensions}
                            </td>
                        </tr>
                    {/if}
                    {#if product.caratWeight}
                        <tr>
                            <th>{translate(label.productCaratSum)}</th>
                            <td>{product.caratWeight}</td>
                        </tr>
                    {/if}
                    {#if product.material}
                        <tr>
                            <th>{translate(label.productMetal)}</th>
                            <td>{product.material}</td>
                        </tr>
                    {/if}
                    {#if product.materialWeight}
                        <tr>
                            <th>{translate(label.productMetalWeight)}</th>
                            <td>{product.materialWeight}</td>
                        </tr>
                    {/if}
                    {#if product.designType}
                        <tr>
                            <th>{translate(label.productDesign)}</th>
                            <td>{product.designType}</td>
                        </tr>
                    {/if}
                </tbody>
            </table>
            {#each product.gemStones as gemStone}
                <h3>{translate(label.gemStone(gemStone.position))}</h3>
                <table class="data-table product-attribute-table">
                    <tbody>
                        {#if gemStone.name}
                            <tr>
                                <th>{translate(label.gemName)}</th>
                                <td>{gemStone.name}</td>
                            </tr>
                        {/if}
                        {#if gemStone.cut}
                            <tr>
                                <th>{translate(label.gemCut)}</th>
                                <td>{gemStone.cut}</td>
                            </tr>
                        {/if}
                        {#if gemStone.caratWeight}
                            <tr>
                                <th>{translate(label.gemCarat)}</th>
                                <td>{gemStone.caratWeight}</td>
                            </tr>
                        {/if}
                        {#if gemStone.dimensions}
                            <tr>
                                <th>{translate(label.gemSize)}</th>
                                <td>{gemStone.dimensions}</td>
                            </tr>
                        {/if}
                        {#if gemStone.count}
                            <tr>
                                <th>{translate(label.gemCount)}</th>
                                <td>{gemStone.count}</td>
                            </tr>
                        {/if}
                        {#if gemStone.setting}
                            <tr>
                                <th>{translate(label.gemSetting)}</th>
                                <td>{gemStone.setting}</td>
                            </tr>
                        {/if}
                        {#if gemStone.originCountry}
                            <tr>
                                <th>{translate(label.gemOrigin)}</th>
                                <td>{gemStone.originCountry}</td>
                            </tr>
                        {/if}
                        {#if gemStone.color}
                            <tr>
                                <th>{translate(label.gemColor)}</th>
                                <td>{gemStone.color}</td>
                            </tr>
                        {/if}
                    </tbody>
                </table>
            {/each}
        </div>
    {/if}
</div>